<template>
  <div>
    <List
      url="getDocumentsProductModelList"
      deleteUrl="deleteDocumentsProductModel"
      :tanle="tanle"
      :update="updateList"
      :data="searchData"
      @add="add"
      @edit="edit"
      :operat="operat"
      :isAdd="true"
    >
      <div slot="Filter">
        <el-input
          v-model="searchData.Key"
          placeholder="Product Model"
          style="width: 300px; margin-left: 10px"
        ></el-input>
        <el-button
          @click="updateList++"
          type="primary"
          style="margin-left: 10px"
          >Search</el-button
        >
      </div>
    </List>
    <UpdateBox
      v-if="updateBlock"
      :updateType="updateType"
      :initForm="updateForm"
      @close="updateBlock = false"
      @update="updateList++"
    >
    </UpdateBox>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/DocumentsProductModel/UpdateBox.vue";
export default {
    components: {
        List,
        UpdateBox
    },
    data() {
        return {
            tanle: [
                { name: "ProductCategory", label: "Product Category" },
                { name: "ProductModel", label: "Product Model" },
                { name: "CreatedTime", label: "Created Time" }
            ],
            updateList: 0,
            updateBlock: false,
            updateType: "add",
            updateForm: {},
            searchData: {
                Key: ""
            },
            operat: [
                {
                    text: "Delete",
                    eventName: "delete",
                    type: "danger",
                    PretreatMethod: "confirmDelete"
                },
                {
                    text: "Edit",
                    eventName: "edit",
                    type: "primary",
                    method(data) {
                        return data.Status !== "1";
                    }
                }
            ]
        };
    },
    created() {},
    methods: {
        add() {
            this.updateForm = {
                ProductCategory:"",
                ProductModel: "",
                CreatedTime: ""
            };
            this.updateType = "add";
            this.updateBlock = true;
        },
        edit(val) {
            this.updateType = "edit";
            this.updateBlock = true;
            this.updateForm = Object.assign({}, val);
        }
    },
    computed: {},
    watch: {}
};
</script>
